// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","header":"_1AMKjpfdN1et5Tr4EcqAmH","paginationButton":"_3y0hWE0JoRN0LHeEddH_u"};